module.exports = __webpack_public_path__ + "static/greycliffcf-regular-webfont-ae5ef48f708b9e7c3365a3e5c2395d8f.woff2";